import { Injectable, signal } from '@angular/core';
import { openDB, IDBPDatabase } from 'idb';

@Injectable({
  providedIn: 'root',
})

export class AudioStorageService {
  private dbPromise: Promise<IDBPDatabase>;
  public availableIds = signal<string[]>([]);

  constructor() {
    this.dbPromise = this.initDB();
    this.setAvailableIds();
  }

  async setAvailableIds(){
    const allKeys: any = await this.getAllKeys();
    this.availableIds.set(allKeys);
  }

  private async initDB() {
    return await openDB('audio-store', 1, {
      upgrade(db) {
        db.createObjectStore('audios');
      },
    });
  }

  async storeAudio(key: string, blob: Blob) {
    const db = await this.dbPromise;
    await db.put('audios', blob, key);
    this.setAvailableIds();
  }

  async getAudio(key: string): Promise<Blob | undefined> {
    try{
      const db = await this.dbPromise;
      return await db.get('audios', key);
    }
    catch(e){
      return undefined;
    }
  }

  async deleteAudio(key: string) {
    const db = await this.dbPromise;
    await db.delete('audios', key);
    this.setAvailableIds();
  }

  async clearAllAudios() {
    const db = await this.dbPromise;
    await db.clear('audios');
    this.setAvailableIds();
  }

  async getAllKeys(): Promise<IDBValidKey[]> {
    const db = await this.dbPromise;
    return await db.getAllKeys('audios');
  }
}
